import axios from 'axios'
import md5 from 'md5'
import { getToken, setToken, removeToken, getTempToken, removeTempToken } from '@/utils/auth'
import { refreshToken } from '@/api/user'

import Vue from 'vue'
import store from '@/store'
import router from '@/router'

const apiRoot = process.env.BASE_API
const appId   = '3baf22637b4a40b0a055c0c2ce5093dc'
const appSec  = '50924a3ea815685c9903bc3f9b16fb39';

/**
 * 请求axios实例
 */
const request = axios.create({
  timeout: 60000
})

request.interceptors.request.use(config => {
  // 正常用户认证信息
  const credentials = getCredentials()
  if (credentials) {
    config.headers['authorization'] = credentials.token
  }
  if (store.state.app.is_prerelease) {
    config.headers['env'] = 'prerelease'
  }
  // 后台管理员代理登录他人token
  // 有此token时，优先使用此token，
  // 则管理员可以代理此token对应用户访问此用户数据
  const tempToken = getTempToken()
  if (tempToken) {
    config.headers['authorization'] = tempToken
  }
  return config
}, error => {
  console.log(error)
  Promise.reject(error)
})

request.interceptors.response.use(
response => {
  const res = response.data

  /**
   * 特殊全局错误处理
   * 业务错误交给外层
   */
  if (res.code == 30001 || res.code == 30011) {
    // Message({
    //   message: '无权限访问或vip等级不足',
    //   type: 'warning',
    //   duration: 5 * 1000
    // })

    return Promise.reject(res)
  } else if (res.code == 20001) {
    // Message({
    //   message: '您已登出',
    //   type: 'warning',
    //   duration: 5 * 1000
    // })

    // delayToLoginPage()

    return Promise.reject(res)
  } else if (res.code == -501) {
    // 用户不存在或状态异常或强制需要登出
    // 清除登录信息
    removeCredentials()

    // 清除缓存
    store.dispatch('removeBaseCache')

    res.message = '状态异常,请刷新页面重试'
    return Promise.reject(res)
  } else if (res.code == -503) {
    // 服务器达到峰值暂停服务情况
    var current_name = ''
    const current = router.history.current
    if (current) {
      current_name = current.name
    }
    const t = res.data.recover_text || ''
    router.replace({
      name: 'server_pause',
      query: {
        t: t,
        from: current_name,
      }
    })
    return Promise.reject(res)
  } else if (res.code == -402) {
    // 班级已解散
    var current_name = ''
    const current = router.history.current
    if (current) {
      current_name = current.name
    }
    res.message = '班级已解散'
    router.replace({
      name: 'join_dissolve',
      query: {
        from: current_name
      }
    })

    return Promise.reject(res)
  } else if (res.code == -401) {
    // 未登录
    /**
     * 临时用户
     *
     * 如果是后台管理员临时登录他人账户
     * 登出后则提示当前账户token已失效，
     * 需要重新去后台登录此账户
     * 
     */
    if (getTempToken()) {
      removeTempToken()

      Vue.$vux.toast.text('此账户token已失效,请重新去后台授权登录此账户继续代理登录')
      return false
    }

    /**
     * 正常用户
     *
     * 判断是否有token,有则刷新token,再重新请求一遍
     */
    const credentials = getCredentials()
    if (credentials) {
      console.log('refreshCredentials-401:', res, credentials)
      return new Promise((resolve, reject) => {
        refreshCredentials(credentials.refresh_token, credentials.openid)
        .then((token) => {
          // 重新请求
          response.config.headers.authorization = token
          
          axios.request(response.config)
          .then((response2) => {
            resolve(response2.data)
          });

        }).catch((e) => {
          console.log('refresh error:', e)
          delayToLoginPage()
        })
      })

    // 没有则去授权登录
    } else {
      console.log('no auth')
      delayToLoginPage()
    }

    res.message = '登录状态已过期'
    return Promise.reject(res)
  }

  return res
},
error => {
  //error code
  //1. ECONNABORTED
  console.log('error: ', error)
  console.log('error code: ', error.code)
  console.log('error message: ', error.message)

  let message = error.message
  let server_error = false
  if (message.indexOf('timeout') >= 0) {
    message = '网络连接超时咯，请稍后再试~'
  } else if (message.indexOf('Network Error') >= 0) {
    if (error.config.url.indexOf('/system/base_data') >= 0) {
      server_error = true
    }
    if (error.config.url.indexOf('user_event_analysis') < 0) {
      message = '网络错误，可稍后重试~'
    } else {
      message = ''
    }
  }
  
  if (error.code == 500) {
    Vue.$vux.confirm.show({
      title: `${message || '网络排队中'}`,
      content: '当前网络拥堵',
      showCancelButton: false,
      confirmText: '3分钟后再来',
      onConfirm: () => {
      },
    })
  } else if (message) {
    error.message = message
    // Vue.$vux.toast.text(message)
  }
  if (server_error) {
    var current_name = ''
    const current = router.history.current
    if (current) {
      current_name = current.name
    }
    router.replace({
      name: 'server_exception',
      query: {
        from: current_name,
      }
    })
  }
  return Promise.reject(error)
})

const delayToLoginPage = () => {
  store.dispatch('startLoading', '重新授权')

  setTimeout(() => {
    const refer = location.href
    store.dispatch('goWechatAuth', {refer})
  }, 500)
}

/**
 * 原生axios请求方法导出
 *
 * url: 网络请求地址
 * method: 请求方式
 * data: 请求数据
 * params: url参数
 * ...
 *
 * 可参考在线文档：https://github.com/axios/axios#request-config
 *
 */
export default request

/**
 * 数据签名
 *
 * @param  {object}  data  [签名对象]
 * @return object {app_id, nonce_str, timestamp, sign}
 */
export function sign(data) {
  const timestamp = Math.floor(Date.now()/1000);
  const nonce_str = Math.random().toString(36).slice(2);

  data.app_id     = appId
  data.timestamp  = timestamp
  data.nonce_str  = nonce_str

  let tmpSign = ''
  Object.keys(data)
  .sort()
  .forEach(function(k, i) {
      if (data[k] && (typeof data[k] == 'string' || typeof data[k] == 'number')) {
        tmpSign += k + data[k]
      }
  })

  //密钥最后参与签名
  tmpSign += appSec;
  let signature = md5(tmpSign).toUpperCase();

  return {
      app_id: appId,
      timestamp: timestamp,
      nonce_str: nonce_str,
      sign: signature
  };
}

/**
 * config:
 *
 * url: api请求路径
 * method: 请求方式
 * data: 请求数据
 * params: url参数
 *
 * withSign:
 * 是否签名，默认不签名
 *
 */
export function apiRequest(config, withSign) {
  config.url = apiRoot + '/v1' + config.url

  // 对restful请求支持
  if (config.url.indexOf('/:') > 0 && (config.params || config.data)) {
    for (let i in config.params) {
      config.url = config.url.replace(':' + i, config.params[i])
    }
    for (let j in config.data) {
      config.url = config.url.replace(':' + j, config.data[j])
    }
  }

  // 对数据进行签名
  if (withSign) {
    let merged    = {...config.params, ...config.data}
    let signature = sign(merged)
    config.params = {...config.params, ...signature}
  }

  // 加上时间戳，防止客户端缓存
  config.params = config.params || {}
  config.params._ = Date.now()

  // config.withCredentials = true

  config.headers = config.headers || {}
  config.headers['clientid'] = appId;
  if (store.state.app.is_miniprogram && store.state.app.mp_app_id) {
    config.headers['appId'] = store.state.app.mp_app_id;
  }
  return request(config)
}

/**
 * post请求API，
 *
 * @param  {string}  path  [请求路径，如/user/123]
 * @param  {object}  data  [数据对象或FormData, File, Blob等]
 * @param  {Boolean} form [是否以表单形式提交，默认json形式]
 * @return Promise
 */
export function apiPost(path, data, form=false, sign=false) {
  const config = {
    method: 'POST',
    url: path,
    data: data
  }

  // 使用表单形式上传
  if (form) {
    config.headers = {}
    config.headers['Content-Type'] = 'application/x-www-form-urlencoded'
  }

  return apiRequest(config, sign)
}

/**
 * get请求API，
 *
 * @param  {string}  path  [请求路径，如/user/123]
 * @param  {object}  query  [请求url参数对象]
 * @return Promise
 */
export function apiGet(path, query={}, sign=false) {
  const config = {
    method: 'GET',
    url: path,
    params: query
  }

  return apiRequest(config, sign)
}

/**
 * get请求API，
 *
 * @param  {string}  path  [请求路径，如/user/123]
 * @param  {object}  query  [请求url参数对象]
 * @return Promise
 */
export function apiDelete(path, query={}, sign=false) {
  const config = {
    method: 'DELETE',
    url: path,
    params: query
  }

  return apiRequest(config, sign)
}

/**
 * put请求API，
 *
 * @param  {string}  path  [请求路径，如/user/123]
 * @param  {object}  data  [数据对象或FormData, File, Blob等]
 * @param  {Boolean} form [是否以表单形式提交，默认json形式]
 * @return Promise
 */
export function apiPut(path, data, form=false, sign=false) {
  const config = {
    method: 'PUT',
    url: path,
    data: data
  }

  // 使用表单形式上传
  if (form) {
    config.headers = {}
    config.headers['Content-Type'] = 'application/x-www-form-urlencoded'
  }

  return apiRequest(config, sign)
}

/**
 * patch请求API，
 *
 * @param  {string}  path  [请求路径，如/user/123]
 * @param  {object}  data  [数据对象或FormData, File, Blob等]
 * @param  {Boolean} form [是否以表单形式提交，默认json形式]
 * @return Promise
 */
export function apiPatch(path, data, form=false, sign=false) {
  const config = {
    method: 'PATCH',
    url: path,
    data: data
  }

  // 使用表单形式上传
  if (form) {
    config.headers = {}
    config.headers['Content-Type'] = 'application/x-www-form-urlencoded'
  }

  return apiRequest(config, sign)
}

/**
 * 存储认证信息
 */
export function storeCredentials(token, refreshToken, openid) {
  let encryptToken = btoa( JSON.stringify({token:token, refresh_token: refreshToken, openid: openid}) ) + '='
  setToken(encryptToken)
}

/**
 * 清除登录信息
 */
export function removeCredentials() {
  removeToken()
}

/**
 * 清除临时登录信息
 */
export function removeTempCredentials() {
  if (getTempToken()) {
    removeTempToken()
  }
}

/**
 * 取出认证信息
 */
export function getCredentials() {
  if (process.env.NODE_ENV == 'development') {
    return {
      "token":"a4b1d1535bec74b43dde25551d587ada",
      "refresh_token":"",
      "openid":"oBn5ywuGTGDc80sqIY00MTi9G9B8"
      }
  }

  let encryptToken = getToken()
  if (!encryptToken) return null

  encryptToken = encryptToken.replace(/\=$/, '')
  const json = atob(encryptToken)

  try {
    const credentials = JSON.parse(json)
    return credentials
  } catch(e) {
    return null
  }
}

/**
 * 刷新认证信息
 */
export function refreshCredentials(refresh_token, openid) {
  return new Promise((resolve, reject) => {
    refreshToken(refresh_token, openid)
    .then((res) => {
      if (res.code == 1) {
        const token = res.data.token
        refresh_token = res.data.refresh_token
        // 保存
        storeCredentials(token, refresh_token, openid)

        resolve(token)
      } else {
        reject(res)
      }
    }).catch((e) => {
      reject(e)
    })
  })
}



// WEBPACK FOOTER //
// ./src/utils/request.js